function validateExistenceOnLastName(maternal, paternal){
    if(maternal.length <= 0 && paternal.length <= 0){
        return false;
    }
    return true;
}

export {
    validateExistenceOnLastName
}